export const MATCH_SRA_TO_EMPLOYEE_RECORD = "MATCH_SRA_TO_EMPLOYEE_RECORD";
export const MATCH_SRA_TO_NEW_EMPLOYEE_RECORD = "MATCH_SRA_TO_NEW_EMPLOYEE_RECORD";
export const LOAD_PARTIALL_MATCHED_SRA_DETAIL = "LOAD_PARTIALL_MATCHED_SRA_DETAIL";
export const RERUN_PARTIALL_MATCHED_SRA_DETAIL = "RERUN_PARTIALL_MATCHED_SRA_DETAIL";
